<template>
  
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md3>
          <v-card>
            <div v-if="isMobileApp" class="text-xs-center">
              <img src="../assets/images/user.png" alt="user" width="150" height="150">
            </div>
            <v-toolbar v-else color="white" class="elevation-0 login-toolbar">
              <v-toolbar-title class="grey--text text--darken-2">Login</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn flat small color="primary" class="text-transform-none font-weight-thin" to="/forgot-password">Forgot Password?</v-btn>
            </v-toolbar>
            <v-form class="pa-3" v-model="valid" v-on:submit.prevent="login">
              <v-card-text>
                <v-text-field v-model="username" ref="username" :disabled="processing" :rules="usernameRules" prepend-icon="person" name="login" label="Login" type="text" required autofocus></v-text-field>
                <v-text-field v-model="password" :disabled="processing" :rules="passwordRules" id="password" prepend-icon="lock" name="password" label="Password" type="password" required></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer v-if="!isMobileApp"></v-spacer>
                <v-btn type="submit" block round :disabled="!valid || processing" :loading="processing" color="primary" class="px-4">
                Login
                <span slot="loader">Processing...</span>
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <powered-by v-if="!isMobileApp" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>  

</template>

<script>

  import PoweredBy from '../components/PoweredBy'

  export default {
    data () {
      return {
        valid: false,
        processing: false,
        username: '',
        usernameRules: [
          v => !!v || 'Username is required',
          v => v.length >= 3 || 'Username must be more than 3 characters'
        ],
        password: '',
        passwordRules: [
          v => !!v || 'Password is required',
          v => v.length >= 5 || 'Password must be more than 5 characters'
        ],
      }
    },

    methods: {
      login () {
        this.processing = true
        this.axios.post(this.config.apis.login, {
            username: this.username, 
            password: this.password
          })
          .then((response) => {
            
            if (response.data.success) {
              this.notify('loginSuccess', 'success')
              this.$router.push('dashboard')
            }
            else{
              this.notify('loginError', 'error')
              this.processing = false
            }

          })
          .catch( error => {
            this.processing = false
          });
      }
    },

    components: {
      'powered-by': PoweredBy
    },

    mounted () {
      this.$refs.username.focus()
    },

  }

</script>

<style scoped>

  .mobile-app .v-card {
    background-color: transparent;
    box-shadow: none !important;
  }
  .mobile-app .v-btn--block {
    height: 42px;
  }

</style>
